import axios from "axios";

const API_URL = process.env.REACT_APP_API_Link;
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN;
const username = process.env.REACT_APP_API_USERNAME;
const password = process.env.REACT_APP_API_PASSWORD;
const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");

const getStoreLocation = () => {
  return axios({
    method: "GET",
    url: API_URL + "register/stores/" + API_ORIGIN,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};
const regData = (bodyFormData) => {
  return axios({
    method: "POST",
    url: API_URL + "register/add/" + API_ORIGIN,
    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
    },
  });
};
const getSitePermissions = () => {
  return axios({
    method: "GET",
    url: `${API_URL}sites/list-syc-sites/${API_ORIGIN}`,
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
};
const RegisterService = {
  getStoreLocation,
  regData,
  getSitePermissions,
};

export default RegisterService;
